import { useEffect, useState } from 'react'
import { Table, Col, Row, Input, Breadcrumb } from 'antd'
import { trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { CONFIG_URL, DATE_FORMAT_CLIENT_PARAMS } from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../common'
import moment from 'moment'
import 'moment/locale/vi'
import useWindowDimensions from '../../common/useWindowDimensions'
import { getPage } from 'src/helpers/constants'
import TopupAdminModal from 'src/common/components/topup/TopupAdminModal'
import ImportExportHistory from './ImportExportHistory'
import ProductDeliveryScreen from './ProductDelivery'
import { formatCurrency } from 'src/helpers/functions'
import ImagePreview, { getImageUrl } from 'src/common/components/ImagePreview'

const TYPE_SCREEN = { list_product: '1', historyImportExport: '2' }
const Product = observer((props: any) => {
   const { t } = useTranslation()
   const FundStore = useStore('FundStore')
   const [textSearch, set_textSearch] = useState('')
   const { height } = useWindowDimensions()
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [isLoading, setIsLoading] = useState(false)
   const [startTime, setStartTime] = useState(moment().subtract(1, 'months'))
   const [endTime, setEndTime] = useState(moment())

   const [item, setItem] = useState(null)
   const [topup, setTopup] = useState(null)
   const [sortDateDesc, setSortDateDesc] = useState(true)
   const [visibleExport, setVisibleExport] = useState(false)
   const [isTopupModalOpen, setIsTopupModalOpen] = useState(false)
   const [visibleView, setVisibleView] = useState<any>(TYPE_SCREEN.list_product)

   useEffect(() => {
      getListData(0, {
         text: trim(textSearch),
         from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
      })
      // FundStore.getTotalPrice(
      //    moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
      //    moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
      // )
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch, startTime, endTime])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage)
         const params = { offset, ...param }
         console.log('props?.b', props?.bill, 'props?.bill?.id', props?.bill?.id)
         await FundStore.getProductList(props?.bill?.id, params)
      } catch (error) {
         //  console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   const onRefreshList = () => {
      getListData(0, {
         text: trim(textSearch),
         from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
      })
   }

   const handleCloseTopup = () => {
      setIsTopupModalOpen(false)
   }

   const columns = [
      {
         title: 'SKU',
         dataIndex: 'id',
         key: 'id',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Tên sản phẩm',
         dataIndex: 'product',
         key: 'product',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value?.name}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.image),
         dataIndex: 'product',
         width: 80,
         key: 'product',
         render: (value: any) => {
            return value?.images?.[0] ? (
               <ImagePreview src={getImageUrl(value.images?.[0], CONFIG_URL.IMAGE_URL)} size={64} fit="contain" />
            ) : (
               <></>
            )
         }
      },

      {
         title: 'Số lượng',
         dataIndex: 'qty',
         key: 'qty',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true)}</span>
         }
      },
      {
         title: 'Đơn giá',
         dataIndex: 'baseCost',
         key: 'baseCost',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true)}đ</span>
         }
      },
      {
         title: 'Thành tiền',
         dataIndex: 'baseCost',
         key: 'baseCost',
         width: 120,
         render: (value: any, record: any) => {
            return <span className="txtMax2Line">{formatCurrency(value * record.qty, true)}đ</span>
         }
      }
      // {
      //    title: 'Tồn kho',
      //    dataIndex: 'inventory',
      //    key: 'inventory',
      //    width: 120,
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{value}</span>
      //    }
      // }
      // {
      //    title: 'action',
      //    key: 'action',
      //    dataIndex: 'updatedAt',
      //    width: 120,
      //    align: 'center' as 'center',
      //    fixed: 'right' as 'right',
      //    render: (text: string, record: any) => {
      //       return (
      //          <span className="txtMax2Line">
      //             <span onClick={() => showHistory(record)} className="gx-link">
      //                {'Lịch sử nhập xuất1'}
      //             </span>
      //          </span>
      //       )
      //    }
      // }
   ]

   // const renderPagination = () => {
   //    if (isEmpty(rows)) {
   //       return null
   //    }

   //    return (
   //       <div className="containerPagination">
   //          <Pagination
   //             onChange={onChange}
   //             pageSize={PAGE_SIZE}
   //             current={offset / PAGE_SIZE + 1}
   //             showSizeChanger={false}
   //             total={count}
   //          />
   //       </div>
   //    )
   // }

   function onChangeTable(pagination: any, filters: any, sorter: any, extra: any) {
      // console.log('params', pagination, filters, sorter, extra)
      if (sorter.order === 'ascend') {
         setSortDateDesc(false)
      } else {
         setSortDateDesc(true)
      }
   }
   const showListProduct = () => {
      setVisibleView(TYPE_SCREEN.list_product)
      // setTimeout(() => {
      //    setVisibleDetail(true)
      // }, 500)
   }
   return visibleView == TYPE_SCREEN.list_product ? (
      <>
         <Loading isLoading={isLoading} />
         <Row>
            <Col span={24}>
               <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                     <span
                        className="gx-link"
                        style={{ textDecoration: 'underline' }}
                        onClick={() => props.showWarehouse()}
                     >
                        Kho hàng
                     </span>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link">{props?.stores?.name}</Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link" onClick={() => props.showBill()}>
                     <span
                        className="gx-link"
                        style={{ textDecoration: 'underline' }}
                        // onClick={() => props.showBill()}
                     >
                        Danh sách phiếu
                     </span>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link">{props?.bill?.id}</Breadcrumb.Item>
                  <Breadcrumb.Item>
                     <span>Danh sách sản phẩm</span>
                  </Breadcrumb.Item>
               </Breadcrumb>

               {/* <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     <Input.Search
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.txtSearch)}
                        allowClear
                     />
                  </Col>
                  <Col xs={24} md={12}>
                     <div className="text-right">
                        <Space>
                           {renderFilter()}
                           <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />
                              {t(GLOBAL_CLIENT.create)}
                           </Button>
                        </Space>
                     </div>
                  </Col>
               </Row> */}
               <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     <Input.Search
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.txtSearch)}
                        allowClear
                     />
                  </Col>
                  <Col xs={24} md={12}></Col>
               </Row>

               {/* <Space className="total-items">
                  {t(GLOBAL_CLIENT.totalItems)}: {count}
               </Space> */}

               <Table
                  // scroll={{ x: 1200 }}
                  scroll={{ y: height - 280 }}
                  columns={columns}
                  dataSource={FundStore.productListList}
                  rowKey="id"
                  pagination={false}
                  onChange={onChangeTable}
               />

               {/* {renderPagination()} */}
            </Col>
         </Row>
         {isTopupModalOpen && (
            <TopupAdminModal
               isTopupModalOpen={isTopupModalOpen}
               topup={topup}
               handleCancel={handleCloseTopup}
               onRefreshList={onRefreshList}
            />
         )}
         <ProductDeliveryScreen visible={visibleExport} />
      </>
   ) : (
      <ImportExportHistory
         showProduct={showListProduct}
         showBill={props.showBill}
         showWarehouse={props.showWarehouse}
         detail={item}
      />
   )
})

export default Product
